import React from 'react';
import clsx from 'clsx';
import styles from './Menu.module.scss';
import { Link } from '@/i18n/navigation';
import Img from '../Img';
import { useIsActiveMenuItem } from './useActiveMenuItem';
import { IMenuItem } from './Navigation.type';

interface IMenu {
  menu: IMenuItem[];
  onClick?: () => void;
  isOpen: boolean;
}

const MenuItem = ({ item, onClick }: { item: IMenuItem, onClick?: () => void; }) => {
  const isActive = useIsActiveMenuItem(item.link, true);

  return (
    <Link
      href={item.link}
      onClick={onClick}
      className={clsx(styles.dropdownItem, {
        [styles.active]: isActive,
      })}
    >
      {item.image && (
        <Img
          src={item.image.url}
          height={24}
          width={24}
          alt=''
        />
      )}
      <span>{item.title}</span>
    </Link>
  );
};

const Menu = ({ menu, onClick, isOpen }: IMenu) => (
  <div className={clsx(styles.dropdownMenu, { [styles.open]: isOpen })}>
    {menu.map((subItem) => (
      <MenuItem
        key={subItem.title}
        item={subItem}
        onClick={onClick}
      />
    ))}
  </div>
);

export default Menu;
